import _ from 'lodash';
import { JSX } from 'react';
import { Link } from 'react-router-dom';
import useBreakpoints from '../hooks/useBreakpoints';
import Icons from './Icons';

export interface Breadcrumb {
  element: JSX.Element;
  path: string;
}

export default function Breadcrumbs(props: {
  entries: Breadcrumb[];
  className?: string;
}) {
  const { isTablet } = useBreakpoints();
  const classNames = `section-breadcrumbs ${props.className ?? ''}`.trim();
  const lastEntryIndex = props.entries.length - 1;

  return (
    <section className={classNames}>
      <div className="container">
        <ul className="breadcrumbs">
          {_.map(props.entries, (e, i) => (
            <li key={e.path}>
              {i !== lastEntryIndex || isTablet ? (
                <Link to={e.path}>{e.element}</Link>
              ) : (
                <a href={e.path} style={{ pointerEvents: 'none' }}>
                  {e.element}
                </a>
              )}
              {i < props.entries.length - 1 && <Icons.ArrowRight />}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
